import { Routes, Route } from "react-router";
import RequireAuth from "../auth/RequireAuth";
import PrivateLayout from "../layouts/PrivateLayout";
import PublicLayout from "../layouts/PublicLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import NotFound from "../pages/NotFound/NotFound";

const AppRoutes = () => (
  <Routes>
    {/* Protected Routes */}
    <Route element={<RequireAuth />}>
      <Route element={<PrivateLayout />}>
        <Route path="/" element={<Dashboard />} />
          <Route path=":session_token" element={<Dashboard />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>

    {/* Public Routes */}
    <Route element={<PublicLayout />}>
      {/* <Route path="/auth-callback" element={<LoginCallback />} /> */}
      <Route path="/error" element={<ErrorPage />} />
      <Route path="*" element={<NotFound />} />
    </Route>
  </Routes>
);

export default AppRoutes;
